export const ACTION_CHANGE_EMAIL = '/Account/validateAndChangeEmail';